module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"line-width":"Толщина линии","border-color":"Обводка секций","background":"Заливка секций","point":"Заливка точки","point-border":"Обводка точки"},"en":{"line-width":"Line width","border-color":"Border color","background":"Background color","point":"Point color","point-border":"Point border color"}}')
  delete Component.options._Ctor
}
